// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visible {
   opacity: 1
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

::ng-deep .mat-button-focus-overlay {
   background-color: transparent !important;
}

mat-dialog-content{
   margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/dialog/delete-form/delete-form.component.css"],"names":[],"mappings":"AAAA;GACG;AACH;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wCAAwC;AAC3C;;AAEA;GACG,mBAAmB;AACtB","sourcesContent":[".visible {\n   opacity: 1\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n::ng-deep .mat-button-focus-overlay {\n   background-color: transparent !important;\n}\n\nmat-dialog-content{\n   margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
